/*
 * @Date: 2026-07-02 10:00:00
 * @Description: 场景价格管理路由
 */

import ScenePriceMgmtList from '../views/scene-price-mgmt-list.vue';
import ScenePriceMgmtConfig from '../views/scene-price-mgmt-config.vue';

export const route = [
  {
    path: '/main/industry/scene-price-mgmt',
    name: 'scene-price-mgmt',
    redirect: '/main/industry/scene-price-mgmt/list',
    meta: {
      title: '场景价格管理'
    },
    children: [
      {
        path: '/main/industry/scene-price-mgmt/list',
        name: 'scene-price-mgmt-list',
        meta: {
          title: '场景价格管理'
        },
        component: ScenePriceMgmtList
      },
      {
        path: '/main/industry/scene-price-mgmt/config',
        name: 'scene-price-mgmt-config',
        meta: {
          title: '工业场景价格配置',
          parentPath: '/main/industry/scene-price-mgmt/list'
        },
        component: ScenePriceMgmtConfig
      },
      {
        path: '/main/industry/scene-price-mgmt/add',
        name: 'scene-price-mgmt-add',
        redirect: '/main/industry/scene-price-mgmt/list'
      }
    ]
  }
];
